/* eslint-disable react/jsx-pascal-case */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import NewContentList from "./NewContentList";

import Event202107_contentList from "./Event202107_contentList";

import "../../css/event210621.css";

import { toast } from "react-toastify"; //토스트(toast)
import moment from "moment";
// import { isMobile } from "react-device-detect";

class Event202107_newContent extends Component {
  state = {
    eventCode: 0,
  };

  _goVod = (code) => {
    const { history, setEventIdx } = this.props;
    setEventIdx(0);
    if (code === "4" || code === "5") {
      history.push("/list?q=tag&c=" + code);
    } else {
      history.push("/list?q=genre&c=" + code);
    }
  };
  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };
  _pass = () => {
    const { history, setEventIdx } = this.props;
    setEventIdx(0);
    history.push("/ticket");
  };
  _timeTable = () => {
    const { setTimelineWeek } = this.props;
    const curDate = new Date();
    const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    let os = "";

    const mobile = /iphone|ipad|ipod|android/i.test(
      navigator.userAgent.toLowerCase()
    );

    if (mobile) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search("android") > -1) {
        os = "android";
      } else if (
        userAgent.search("iphone") > -1 ||
        userAgent.search("ipod") > -1 ||
        userAgent.search("ipad") > -1
      ) {
        os = "ios";
      } else {
        os = "otehr";
      }
    } else {
      os = "pc";
    }

    if (today <= "2021-03-31 00:00:00") {
      toast.warn("3월 31일 이후 확인이 가능합니다.");
    } else {
      //alert(0)
      //setEventIdx(0)
      if (os === "pc") {
        setTimelineWeek(true);
      } else {
        if (os === "ios") {
          setTimeout(function () {
            window.open("https://apps.apple.com/kr/app/id687631772", "", "");
          }, 1500);

          window.location.href = "aniplustv://TimeTable";
        } else {
          //setTimeout(function () {
          //window.open(android_appstore_url);
          //}, 1500);

          window.location.href = "aniplustv://TimeTable";
        }

        //this.action_app('aniplustv://TimeTable', 'aniplustv://TimeTable', 'https://itunes.apple.com/kr/app/instagram/id687631772', 'https://play.google.com/store/apps/details?id=com.aniplustv.android')
      }
    }
  };
  _goGoogle = () => {
    window.open("https://forms.gle/kwapMGR6eMBzhTKt6", "", "");
  };

  render() {
    // const bgImg = "//img/event/20210317/bg.png";
    // const curDate = new Date();
    // const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    return (
      <Fragment>
        <div className="event_head">
          {/*<button type="button" onclick="history.back()"><img src="/img/event/back.png" alt="뒤로"/></button>*/}
          <h3>애니플러스 신작 이벤트</h3>
          <button type="button" className="btnClose">
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event210621">
            <div className="sticky">
              <div className="quick">
                <a href="#top">
                  <img src="/img/event/event210621/quick01.png" alt="top" />
                </a>
                <a href="#newList">
                  <img
                    src="/img/event/event210621/quick02.png"
                    alt="신작목록"
                  />
                </a>
                <a href="#gift">
                  <img src="/img/event/event210621/quick03.png" alt="경품" />
                </a>
                <a style={{ cursor: "pointer" }} onClick={this._timeTable}>
                  <img
                    src="/img/event/event210621/quick04.png"
                    alt="요일별시간표"
                  />
                </a>
                <a href="#comment">
                  <img src="/img/event/event210621/quick05.png" alt="댓글" />
                </a>
              </div>
            </div>
            <div className="main">
              <a
                onClick={this._goGoogle}
                className="link"
                name="top"
                style={{ cursor: "pointer" }}
              ></a>
              <img
                src="/img/event/event210621/backimg_1.png"
                alt="애니플러스밖에 없는 3분기 인기작을 다 가져와 버렸다!!!"
                className="img_web"
              />
              <img
                src="/img/event/event210621/backimg_m1.png"
                alt="애니플러스밖에 없는 3분기 인기작을 다 가져와 버렸다!!!"
                className="img_m"
              />
              <div className="peng">
                <img src="/img/event/event210621/peng.png" />
              </div>
            </div>
            <div className="listWrap">
              <a href="#" className="link" name="newList"></a>

              <Event202107_contentList eventCode={1} />

              <Event202107_contentList eventCode={2} />
              <Event202107_contentList eventCode={3} />
              <Event202107_contentList eventCode={4} />
              <Event202107_contentList eventCode={5} />
            </div>
            <div className="btm">
              <a
                onClick={this._timeTable}
                className="link"
                name="gift"
                style={{ cursor: "pointer" }}
              ></a>
              <img
                src="/img/event/event210621/backimg_2.png"
                alt="경품내용 및 주의사항"
                className="img_web"
              />
              <img
                src="/img/event/event210621/backimg_m2.png"
                alt="경품내용 및 주의사항"
                className="img_m"
              />
            </div>
          </div>
        </div>
        <a href="#" name="comment"></a>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202107_newContent));
